import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import React, { use } from 'react';
import { Middleware, MiddlewareAdmin } from './Middleware';
import { TokenValidateExpiration } from './Token';
import { useParams } from 'react-router-dom';

const token = localStorage.getItem("token");

function AdminProviderResendInvitationSend() {
    document.getElementById("messageError").style.display = "none";
    document.getElementById("messageError").innerHTML = "";
    document.getElementById("form").style.display = "none";
    document.getElementById("ChgB").style.display = "block";

    var rfc = document.getElementById("rfc").value;
    var oldEmail = document.getElementById("oldEmail").value;
    var newEmail = document.getElementById("newEmail").value;

    var email = "";

    var passwordChecked = false

    if (document.getElementById("passwordDefault").checked == true) {
        passwordChecked = true;
    } else {
        passwordChecked = false;
    }

    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/inviter/resend-invitation/'+token, {
        OldEmail: oldEmail,
        NewEmail : newEmail,
        RFC: rfc,
        Password: passwordChecked,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    ).then(response => {
        window.scrollTo(0, 0);
        document.getElementById("form").style.display = "none";
        document.getElementById("messageError").style.display = "none";
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = "Invitación reenviada al proveedor " + rfc + ", redirigiendo a la página principal, espere...";
        setTimeout(() => {
            window.location.href = '/administrador';
        }, 3000);
    })
    .catch(error => {
        window.scrollTo(0, 0);
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageError").style.display = "block";
        document.getElementById("messageError").innerHTML = "Error al reenviar la invitación, es probable que el correo ya haya sido asignado a otra cuenta, redirigiendo a la página principal, por favor espere...";
        setTimeout(() => {
            window.location.href = '/administrador';
        }, 3000);
    });
}

function AdminProviderResendInvitation() {
    Middleware();
    MiddlewareAdmin();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    var decode = "";

    decode = jwtDecode(token);

    var { provider } = useParams();

    var { email } = useParams();

    var { rfc } = useParams();

    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        decode.email
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Reenviar invitación</h1>
                        <br></br>
                        <div>
                            <p><i id="ChgB" className="fa fa-spinner fa-spin Chg"></i></p>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageError' className='Error-Notification'></label>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageSuccess' className='Success-Notification'></label>
                        </div>
                        <div>
                            <form id='form' action={AdminProviderResendInvitationSend}>
                                <label className='text-secondary'>RFC asignado, no editable</label>
                                <br></br>
                                <input type="text" id="rfc" className='Input-Style' value={rfc} disabled></input>
                                <br></br>
                                <br></br>
                                <label className='text-secondary'>Correo electrónico actual</label>
                                <br></br>
                                <input type='hidden' id='oldEmail' className='Input-Style' value={email.toLowerCase()}></input>
                                <input type="email" id="newEmail" className='Input-Style' placeholder={email.toLowerCase()}></input>
                                <br></br>
                                <br></br>
                                <label className='text-secondary'><input type='checkbox' id='passwordDefault' className='m-2'></input>Asignar password por default (999999999999)</label>
                                <br></br>
                                <br></br>
                                <input type='submit' className='Button-Style' value="Enviar"></input>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminProviderResendInvitation;